import { useState } from 'react';
import { useApi } from '../lib/hooks';
import { useSession } from '../app/session';
import { Screen } from '../components/Chrome';
import { TelegramIcon } from '../components/icons';
import { isTelegram } from '../lib/telegram';

/** P1 · Вход (SPEC §5). Один путь и для входа, и для регистрации. */

interface AuthConfig {
  botUsername: string | null;
  telegramReady: boolean;
  devLogin: boolean;
}

const FEATURES = [
  { icon: '/assets/ui/tab-workouts.webp', label: 'Журнал тренировок' },
  { icon: '/assets/ui/tab-food.webp', label: 'Дневник питания' },
  { icon: '/assets/leagues/04-gold.webp', label: 'Соревнования и награды' },
];

export function LoginScreen() {
  const { loginWithTelegram, loginAsDev } = useSession();
  const { data: config } = useApi<AuthConfig>('/api/auth/config');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [devName, setDevName] = useState('');

  const inTelegram = isTelegram();

  const handleTelegram = async () => {
    setBusy(true);
    setError(null);
    try {
      await loginWithTelegram();
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось войти');
      setBusy(false);
    }
  };

  const handleDev = async () => {
    if (devName.trim().length < 2) {
      setError('Введите имя');
      return;
    }
    setBusy(true);
    setError(null);
    try {
      await loginAsDev(devName.trim());
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Не удалось войти');
      setBusy(false);
    }
  };

  return (
    <Screen deep wide>
      <div className="stage">
        <img src="/assets/ui/app-icon.webp" alt="Логотип jungles" />
      </div>
      <h1 className="name">jungles</h1>
      <p className="lead">Тренировки и питание определяют — кто король этих джунглей</p>

      <div className="feat">
        {FEATURES.map((feature) => (
          <div key={feature.label}>
            <img src={feature.icon} alt="" />
            {feature.label}
          </div>
        ))}
      </div>

      <div className="foot">
        {inTelegram || config?.telegramReady ? (
          <button className="b p hero" type="button" onClick={handleTelegram} disabled={busy}>
            {busy ? (
              <>
                <span className="spinner" style={{ width: 20, height: 20, borderWidth: 2 }} />
                Подтвердите в Telegram
              </>
            ) : (
              <>
                <TelegramIcon />
                Войти через Telegram
              </>
            )}
          </button>
        ) : null}

        {!inTelegram && config?.devLogin ? (
          <div style={{ marginTop: config.telegramReady ? 12 : 0 }}>
            <label className="fl sm" htmlFor="dev-name">
              Локальный вход для разработки
            </label>
            <input
              id="dev-name"
              className="f"
              value={devName}
              onChange={(event) => setDevName(event.target.value)}
              placeholder="Ваше имя"
              autoComplete="off"
            />
            <button
              className="b p big"
              type="button"
              onClick={handleDev}
              disabled={busy}
              style={{ width: '100%', marginTop: 10 }}
            >
              Войти
            </button>
          </div>
        ) : null}

        {!inTelegram && !config?.devLogin && !config?.telegramReady ? (
          <p className="nt" style={{ textAlign: 'center' }}>
            Откройте приложение из Telegram — вход работает там.
          </p>
        ) : null}

        {error ? (
          <p className="err" style={{ textAlign: 'center' }}>
            {error}
          </p>
        ) : null}

        <p className="nt" style={{ textAlign: 'center', margin: '12px 10px 0' }}>
          Аккаунт создастся сам, пароль не нужен. Продолжая, вы принимаете{' '}
          <a href="#terms">условия</a> и <a href="#privacy">политику</a>.
        </p>
      </div>

      <img className="strip" src="/assets/ui/jungle-strip.webp" alt="" />
    </Screen>
  );
}
